module.exports = __webpack_public_path__ + "static/img/video_chatbot_platform.917e36ad.png";